import {
    SET_GLOBAL_SEARCH,
    SET_BREADCRUMB_REDIRECT_STATUS
} from './types';

const setGlobalSearch = (globalSearchValues: any) => ({
    type: SET_GLOBAL_SEARCH,
    globalSearchValues
})

const setBreadCrumbRedirect = (BreadCrumbRedirectPrameter: any) => ({
    type: SET_BREADCRUMB_REDIRECT_STATUS,
    BreadCrumbRedirectPrameter,
})

export {
    setGlobalSearch,
    setBreadCrumbRedirect
};
